export function ytThumbUrl(id) {
  if (!id) return "";
  return `https://img.youtube.com/vi/${id}/default.jpg`;
}